import React from "react";

import { Collapse, Box, Group, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown } from "@tabler/icons-react";

interface SectionToggleProps {
  title: string;
  children: React.ReactNode;
  initiallyOpen?: boolean;
  rightSection?: React.ReactNode;
  suppressArrow?: boolean;
  opened?: boolean;
}

export function SectionToggle({
  title,
  children,
  rightSection,
  initiallyOpen = false,
  suppressArrow = false,
  opened,
}: SectionToggleProps) {
  const [open, { toggle }] = useDisclosure(initiallyOpen);

  const finalOpened = opened ?? open;

  return (
    <Box
      w="100%"
      py={8}
      px={{
        /*
         * Not great.
         *
         * The way this component is structured it's not easily composable
         * or overridable. Rather than drilling style props all the way down
         * from a parent, for now we make an assumption that, at mobile
         * breakpoints, the entries will be rendered outside of a grid-layout
         * and therefore need additional padding.
         */
        base: 16,
        lg: 0,
      }}
    >
      <Group w="100%" justify="space-between" onClick={toggle} sx={{ cursor: "pointer" }} px={8}>
        <Title order={6}>{title}</Title>
        <Group>
          {rightSection}
          {!suppressArrow && (
            <IconChevronDown
              size={16}
              style={{
                transform: finalOpened ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease-in-out",
                marginLeft: 8,
              }}
            />
          )}
        </Group>
      </Group>
      <Collapse in={finalOpened} transitionDuration={200}>
        <Box px={8}>{children}</Box>
      </Collapse>
    </Box>
  );
}
